@charset "UTF-8";

@use "@user/assets/css/variables";

.dashboard-contents {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 0 12px 12px;

  // 상단 정보
  >div:nth-child(1) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 8px 32px;
    border-radius: 20px;
    background: variables.$colorBgBase;

    >p {
      color: variables.$colorMain;
    }

    >div {
      min-width: 0;
    }
  }

  // 하단 정보
  >div:nth-child(2) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 12px;
    width: 100%;

    // 세부 공통
    >div {
      min-width: 0;
      padding: 12px 16px 16px;
      border: 1px solid variables.$colorBorderBase;
      border-radius: 8px;
      background: #fff;
      @include variables.transition;

      &:hover {
        box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px;
      }

      >p {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
        min-height: 28px;
        color: variables.$colorMain;
        font-size: 16px;
        font-weight: 700;
      }
    }

    // 작업 지시 정보
    .db-item01 {

      >div {
        display: flex;
        flex-direction: column;
        gap: 12px;

        ul {
          padding: 0 8px 8px;
          border-radius: 6px;
          background: variables.$colorBgBase;

          li {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            gap: 4px;
            padding: 4px 0 4px 8px;
            font-size: 13px;
        
            >p {
              >em {
                color: variables.$colorMain;
                font-size: 28px;
                font-weight: 700;
              }
            }
          }
        }

        // chart
        >div {
          width: 100%;
          min-width: 0;
          display: flex;
          align-items: center;
          max-height: 100px;
        }
      }
    }

    // 입고 정보
    .db-item02 {
      >div {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: start;
        gap: 16px;

        ul {
          display: grid;
          grid-template-rows: 1fr 1fr;
          padding: 0 8px 6px;
          height: 100%;
          border-radius: 6px;
          background: variables.$colorBgBase;

          li {
            display: flex;
            flex-direction: column;
            align-items: baseline;
            gap: 4px;
            min-width: 100px;
            padding: 12px 0 12px 8px;
            font-size: 13px;
        
            >p {
              width: 100%;
              text-align: right;
        
              >em {
                color: variables.$colorMain;
                font-size: 28px;
                font-weight: 700;
              }
            }
          }
        }

        // chart
        >div {
          width: 100%;
          min-width: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    // 출고 정보
    .db-item03 {
      grid-column: 3 / span 2;

      >div {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: start;
        gap: 16px;
        min-width: 0;

        ul {
          display: grid;
          grid-template-rows: 1fr 1fr;
          padding: 0 8px 6px;
          height: 100%;
          border-radius: 6px;
          background: variables.$colorBgBase;

          li {
            display: flex;
            flex-direction: column;
            align-items: baseline;
            gap: 4px;
            min-width: 100px;
            padding: 12px 0 12px 8px;
            font-size: 13px;
        
            >p {
              width: 100%;
              text-align: right;
        
              >em {
                color: variables.$colorMain;
                font-size: 28px;
                font-weight: 700;
        
                &.increase {
                  color: variables.$colorFontIncrease;
                }
        
                &.decrease {
                  color: variables.$colorFontDecrease;
                }
              }
            }
          }
        }

        // chart
        >div {
          display: flex;
          flex-direction: column;
          gap: 8px;

          >div {
            width: 100%;
            min-width: 0;
            display: flex;
            align-items: center;

            &:first-child {
              width: 90%;
              margin: 0 5%;
            }
          }
        }
      }
    }

    // 재고 정보
    .db-item04 {
      grid-row: 2 / span 3;

      >div {
        min-width: 0;

        li {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          gap: 4px;
          min-height: 28px;
          padding: 4px 0 4px 16px;
          font-size: 13px;
      
          >div {
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 14px;
          }
        }

        // chart
        >div {
          width: 100%;
          min-width: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    // CELL 정보
    .db-item05 {
      grid-row: 2 / span 2;

      >div {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        align-items: center;
        gap: 8px;
        min-width: 0;

        >div {
          display: grid;
          grid-template-rows: auto 1fr;
          gap: 4px;
          height: 100%;
          padding: 12px;
          font-size: 13px;
          border-radius: 6px;
          background: variables.$colorBgBase;

          >p {
            text-align: right;

            >em {
              color: variables.$colorMain;
              font-size: 22px;
              font-weight: 700;

              &.error {
                color: variables.$colorFontPoint;
              }
            }
          }
        }
      }
    }

     // BackUp 작업
    .db-item06 {
      grid-column: 3;
      grid-row: 2;

      >div {
        min-width: 0;

        ul {
          border-radius: 6px;
      
          li {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
            gap: 4px;
            padding: 4px 0 4px 8px;
            font-size: 13px;
      
            >p {
              >em {
                color: variables.$colorMain;
                font-size: 28px;
                font-weight: 700;
              }
            }
          }
        }
      }
    }

     // 오류 및 미처리 작업
    .db-item07 {
      grid-column: 4;
      grid-row: 2 / span 2;

      >div {
        min-width: 0;
        padding: 12px 0 0;

        li {
          display: flex;
          align-items: baseline;
          justify-content: space-between;
          gap: 4px;
          padding: 6px 0 6px 16px;
          font-size: 13px;
      
          >div {
            display: flex;
            align-items: center;
            gap: 4px;
            font-size: 14px;
          }
        }
      }
    }

    // 시효 만료 예정
    .db-item08 {
      grid-column: 3;
      grid-row: 3;
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 16px;
      padding: 8px 16px;

      >div {
        width: 100%;
        min-width: 0;
        text-align: right;

        >em {
          color: variables.$colorMain;
          font-size: 28px;
          font-weight: 700;
        }
      }
    }

    // 공SKU 정보
    .db-item09 {

      >div {
        display: grid;
        grid-template-columns: 0.9fr 1fr 1fr 1fr;
        align-items: center;
        gap: 8px;
        min-width: 0;
        
        >div {
          display: flex;
          flex-direction: column;
          gap: 4px;
          padding: 6px 8px;
          font-size: 13px;
          text-align: right;
          border: 1px solid variables.$colorBorderBase;
          border-radius: 6px;

          &:nth-child(1),
          &:nth-child(5) {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            color: variables.$colorMain;
            font-weight: 700;
            border: 0;
            border-radius: 6px;
            background: variables.$colorBgBase;
          }

          >span {
            text-align: left;
          }

          >p {
            text-align: right;

            >em {
              color: variables.$colorMain;
              font-size: 16px;
              font-weight: 700;
            }
          }
        }
      }
    }

    // 작업대별 작업 현황
    .db-item10 {
      grid-column: 3 / span 2;

      // chart
      >div {
        width: 100%;
        min-width: 0;
        display: flex;
        align-items: center;
      }
    }
  }
}
